<template>
  <div class="wrapper">
    <div class="register">
      <template v-if="loaded">
        <template v-if="!open">
          <div v-if="!waitlisted" class="waitlist-form">
            <h2>We are currently full!</h2>

            <p>
              To get on the waitlist enter your email.
              We will let you know if we have dropouts.
            </p>

            <input class="text-box" placeholder="email" v-model="email"/>

            <button @click="waitlistMe">Enter</button>
          </div>

          <div v-if="waitlisted" class="confirmation-screen">
            <p>You are waitlisted! We will send you an email if we can get you in.</p>
            <h2>Emails will be sent to:</h2>
            <h3><em>{{ email }}</em></h3>
          </div>
        </template>

        <template v-if="open">

          <div v-if="!registered" class="button-group">
            <div class="button-container">
              <img src="../assets/icons/individual.png"/>
              <button @click="registerType(false)" :class="{selected: isIndividual }">
                Individual
              </button>
            </div>
            <div class="button-container">
              <img src="../assets/icons/group.png"/>
              <button @click="registerType(true)" :class="{ selected: isTeam }">
                Team
              </button>
            </div>
          </div>

          <template v-if="!registered && (isTeam || isIndividual)">

              <form v-if="isIndividual" class="register-form">
                <label>Email</label>
                <input class="text-box" v-model="email"/>
                <label>Name</label>
                <input class="text-box" v-model="name"/>
                <label>Do you want to be timed?</label>
                <p class="form-note"><em>This will be recorded on a 'results' page, and will make you eliable for time-related prizes</em></p>
                <div class="checkbox-group">
                  <input class="checkbox" type="checkbox" v-model="timeMe"/>
                  <label>Yes time me</label>
                </div>
              </form>

              <form v-if="isTeam" class="register-form">
                <label>Email</label>
                <input class="text-box" v-model="email"/>
                <label>Team Name</label>
                <input class="text-box" v-model="teamName"/>
                <label>Team Member names (Max 4)</label>
                <textarea resize="false" v-model="teamMembers"/>
                <label>Do you want to be timed?</label>
                <p class="form-note"><em>This will be recorded on a 'results' page, and will make your team eliable for time-related prizes</em></p>
                <div class="checkbox-group">
                  <input class="checkbox" type="checkbox" v-model="timeMe"/>
                  <label>Yes time us</label>
                </div>
              </form>

              <button @click="register">Register</button>
          
          </template>

          <div class="confirmation-screen" v-if="registered">
            <p>
              You are registered! Congrats!
              You will recieve an email with 24hours confirming your registration.
            </p>

            <template v-if="isIndividual">
              <h2>Email</h2>
              <h3><em>{{ email }}</em></h3>
              <h2>Name</h2>
              <h3><em>{{ name }}</em></h3>
            </template>

            <template v-if="isTeam">
              <h2>Email</h2>
              <h3><em>{{ email }}</em></h3>
              <h2>Team Name</h2>
              <h3><em>{{ teamName }}</em></h3>
              <h2>Team Members</h2>
              <h3><em>{{ teamMembers }}</em></h3>
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { db } from '../../environment.ts';
import moment from 'moment';

export default {
  name: 'Register',
  data: function() {
    return {
      timeMe: true,
      isIndividual: false,
      isTeam: false,
      loaded: false,
      maxTeams: 10,
      maxTeamSize: 4,
      open: true,
      waitlisted: false,
      registered: false,
      name: '',
      email: '',
      teamMembers: '',
      teamNames: '',
      validation: {
        isValid: false,
        messages: []
      }
    }
  },
  firestore() {
    return {
      participants: db.collection('participants'),
      waitlist: db.collection('waitlist')
    }
  },
  mounted() {
    this.$firestore.participants 
    this.$firestore.participants.get().then((snap) => {
      this.open = !(snap.size >= this.maxTeams);
      this.loaded = true;
    })
  },
  methods: {
    registerType: function(isTeam) {
      this.isTeam = isTeam;
      this.isIndividual = !isTeam;
    },
    waitlistMe: function() {
      if (!this.validEmail()) {
         this.$dialog.alert('Please provide a valid email address.')
      } else {
        this.$firestore.waitlist
          .doc(this.email)
          .set({ waitlisted: moment().format('MMMM Do YYYY, h:mm:ss a') });
        this.waitlisted = true;
      }
    },
    register: function() {
      this.validate();
      if (this.validation.isValid) {
        if (this.isTeam) {
          this.registerTeam({
            teamName: this.teamName,
            email: this.email,
            teamMembers: this.teamMembers,
            timeMe: this.timeMe
          })
        } else {
            this.registerParticipant({
            name: this.name,
            email: this.email,
            timeMe: this.timeMe
          });
        }
      } else {
        let alertMessage = ''
        
        this.validation.messages.forEach((msg) => {
          alertMessage += `\n ${msg}` 
        })

        this.$dialog.alert(alertMessage, 
        )
      }
    },
    validate() {
      this.validation.messages = [];
      this.validation.isValid = true;

      if (!this.validEmail()) {
        this.validation.isValid = false;
        this.validation.messages.push('Please provide a valid email address.')
      }
      if (this.isIndividual && !this.validName()) {
        this.validation.isValid = false;
        this.validation.messages.push('Please provide your name.')
      }
      if (this.isTeam && !this.validTeamName()) {
        this.validation.isValid = false;
        this.validation.messages.push('Please provide a team name.')
      }
      if (this.isTeam && !this.validTeamMembers()) {
        this.validation.isValid = false;
        this.validation.messages.push('Please provide team member names.')
      }
    },
    registerTeam(data) {
        const ref = this.$firestore.participants.doc(data.email);
        ref.get().then((docSnapshot) => {
          if (docSnapshot.exists) {
            if (this.$dialog.confirm('There is already a registration associated with this email! Would you you like to overwrite that registration?')) {
              ref.set(data);
              this.registered = true;
            }
          } else {
            ref.set(data);
            this.registered = true;
          }
        })
    },
    registerParticipant(data) {
        const ref = this.$firestore.participants.doc(data.email);
        ref.get().then((docSnapshot) => {
          if (docSnapshot.exists) {
            if (this.$dialog.confirm('There is already a registration associated with this email! Would you you like to overwrite that registration?')) {
              ref.set(data);
              this.registered = true;
            }
          } else {
            ref.set(data);
            this.registered = true;
          }
        })
    },
    validEmail() {
      const s1 = this.email ? this.email.split('@') : []
      const s2 = s1.length > 1 ? s1[1].split('.') : []

      return s2.length === 2
    },
    validName() {
      return this.name !== ''
    },
    validTeamName() {
      return this.teamName !== ''
    },
    validTeamMembers() {
      return this.teamMembers !== ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox-group {
  display: flex;
  align-items: center;
}

.checkbox-group .checkbox {
  width: 20px;
  margin: 0;
  margin-right: 5px;
}

.button-group {
  display: flex;
  margin-bottom: 40px;
  margin-top: 40px;
}

.form-note {
  width: 250px;
  margin-top: 5px;
  text-align: left;
}

.button-group button {
  background: white;
  border: solid 1px;
  margin-right: 0;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.button-container {
  width: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button-container img {
  margin-bottom: 10px;
}

.button-container button {
  margin-top: 10px;
  margin: 0;
}

button.selected {
  background: #0170bf;
  color: white;
}

.register {
  min-height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 500px;
    margin: 40px auto;
    margin-bottom: 0;
    background: white;
    width: 100%;
    max-width: 800px;
    box-sizing: border-box;
    color: black;
    padding: 20px 0;
    height: 100%;
}
.register-form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
}

.register-form textarea {
    width: 250px;
    padding: 5px;
    height: 100px;
    font-size: 14px;
    margin-bottom: 20px;
    border-color: grey;
    border-radius: 5px;
}
.waitlist-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
}
.register-form input {
    margin-top: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
    width: 200px;
    border-style: solid;
    border-width: thin;
    height: 30px;
    border-color: grey;
}

.register-form .text-box,
.waitlist-form .text-box {
   width: 250px;
}

.register-form .vue-numeric-input {
  margin-top: 10px;
  display: flex;
}

.register-form .number-box,
.register-form .number-box input {
  height: 30px
}

.confirmation-screen {
  background: white;
  border-radius: 10px;
  max-width: 400px;
}

.confirmation-screen h2 {
  margin-top: 0;
  margin-bottom: 5px;
}
.confirmation-screen h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-weight: 200;
}
.confirmation-screen p {
  margin-bottom: 40px;
}
</style>
